import React, {Fragment} from "react";
import {Button, Checkbox, Col, Form, Input, Row, Select, Spin} from "antd";
import MaillerUpload from "./MaillerUpload";
import MaillerEditor from "./MaillerEditor";
import MaillerFaq from "./MaillerFaq";
import MaillerTemplate from "./MaillerTemplate";

const MaillerFormView = ({
	action,
	mails,
	document,
	templates,
	requete,
	innerForm,
	isSending,
	open,
	setOpen,
	checked,
	signatureHtml,
	templateHtml,
	faqSelection,
	selectedFaqId,
	selectedTemplateId,
	isUploading,
	setIsUploading,
	handleSubmitClick,
	handleInnerSubmit,
	handleSelectTemplate,
	handleSelectFAQ,
	handleSelectSignature
}) => {
	return (
		<>
			<Spin
				spinning={isSending}
				size="large"
				tip="Envoi en cours..."
			>
			<Row gutter={10} style={{marginBottom: 10}}>
				{action === 'requete' && (
					<Col span={12}>
						<MaillerFaq
							selectedTemplate={selectedFaqId}
							onChange={handleSelectFAQ}
							templates={templates}
						/>
					</Col>
				)}
				<Col span={action === 'requete' ? 12 : 24}>
					<MaillerTemplate
						selectedTemplate={selectedTemplateId}
						onChange={handleSelectTemplate}
						templates={templates}
						requete={requete}
					/>
				</Col>
			</Row>

			<Form
				className="new-mail"
				form={innerForm}
				onFinish={handleInnerSubmit}
				onSubmitCapture={(e) => {
					e.stopPropagation(); // Empêche la propagation vers le formulaire parent
				}}
				autoComplete="off"
			>
				<Form.Item
					label={null}
					name="mail"
					rules={[
						{required: true, message: 'Sélectionner au moins une adresse mail!'},
						{
							validator: (_, value) => {
								if (!value || value.length === 0) {
									return Promise.resolve();
								}
								const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
								const invalidEmails = value.filter(email => !emailRegex.test(email));
								if (invalidEmails.length > 0) {
									return Promise.reject(new Error(`Adresse(s) mail invalide(s): ${invalidEmails.join(', ')}`));
								}
								return Promise.resolve();
							}
						}
					]}
					style={{marginBottom: 10}}
				>
					<Select
						size={"large"}
						mode="tags"
						open={open}
						onDropdownVisibleChange={(visible) => setOpen(visible)}
						style={{width: '100%'}}
						placeholder="Adresses Mail"
						onChange={() => setOpen(false)}
						options={mails}
					/>
				</Form.Item>

				<Form.Item
					label={null}
					name="cc"
					rules={[
						{required: false, message: 'Adresse(s) mail optionnelle(s)!'},
						{
							validator: (_, value) => {
								if (!value || value.length === 0) {
									return Promise.resolve();
								}
								const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
								const invalidEmails = value.filter(email => !emailRegex.test(email));
								if (invalidEmails.length > 0) {
									return Promise.reject(new Error(`Adresse(s) mail invalide(s): ${invalidEmails.join(', ')}`));
								}
								return Promise.resolve();
							}
						}
					]}
					style={{marginBottom: 10}}
				>
					<Select
						size={"large"}
						mode="tags"
						open={false}
						dropdownRender={() => null}
						suffixIcon={null}
						style={{width: '100%'}}
						placeholder="CC"
					/>
				</Form.Item>

				<Form.Item
					label={null}
					name="object"
					rules={[{required: true, message: 'Objet de mail obligatoire!'}]}
					style={{marginBottom: 10}}
				>
					<Input size={"large"} placeholder="Objet"/>
				</Form.Item>

				<div style={{ border: "1px solid #d9d9d9", borderRadius: 4, padding: 10, marginBottom: 10 }}>
					<Form.Item
						name="email_message"
						style={{ marginBottom: 10 }}>
						<MaillerEditor
							mails={mails}
							templateHtml={templateHtml}
							faqSelection={faqSelection}
						/>
					</Form.Item>

					{(signatureHtml && checked) && (
						<div
							style={{ marginTop: 12, paddingTop: 12 }}
							dangerouslySetInnerHTML={{ __html: signatureHtml }}
						/>
					) }
				</div>
				<Row>
					<Col span={12} style={{marginBottom: 10}}>
						<Checkbox checked={checked} onChange={handleSelectSignature} >Avec signature</Checkbox>
					</Col>
				</Row>
				<Form.Item
					name="pieces_jointes"
					valuePropName="fileList"
					initialValue={[]}
					style={{marginBottom: 10}}
				>
					<MaillerUpload
						mails={mails}
						document={document}
						directory={action === 'owner' ? 'Lots/' : 'Requetes/'}
						onLoadingChange={setIsUploading}
					/>
				</Form.Item>

				<Form.Item label={null} style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						size="large"
						type="primary"
						onClick={handleSubmitClick}
						disabled={isUploading}
					>
						Envoyer
					</Button>
				</Form.Item>
			</Form>
			</Spin>
		</>
	);
};

export default MaillerFormView;
